import axios from 'axios';
import router from '../routes';
import helpers from "../helpers";
import store from '../stores';

var url_api = "";

var api = axios.create({
    responseType: 'json',
});


helpers.getEnv().then(async (env) => {
    url_api = await env.VUE_APP_URL_API + "/api";
    api.defaults.baseURL = url_api;
});


var filaRequisicoes = [];

api.interceptors.request.use((config) => {
    if (store.getters.isAuthenticated) {
        return store.dispatch("REFRESH_TOKEN")
            .then(() => {
                config.headers.Authorization = 'Bearer ' + store.getters.token;

                if (config.baseURL == url_api) {
                    //O loading sera controlado por uma fila, de forma ele sera exibido enquanto existir requisicoes na fila para processar
                    filaRequisicoes.push(config);
                    router.app.carregando = true;
                }

                return config;
            }).catch(() => {
                store.dispatch('LOGOUT_REQUEST')
            });
    } else {

        if (config.baseURL == url_api) {
            //O loading sera controlado por uma fila, de forma ele sera exibido enquanto existir requisicoes na fila para processar
            filaRequisicoes.push(config);
            router.app.carregando = true;
        }

        return config;
    }
});


api.interceptors.response.use(
    (response) => {
        if (response.config.baseURL == url_api) {
            //...apenas será invisivel quando a fila estiver esvaziada...
            if (filaRequisicoes.length > 0)
                filaRequisicoes.splice(0, 1);

            if (filaRequisicoes.length <= 0)
                router.app.carregando = false;
        }
        return response;
    },
    (error) => {
        filaRequisicoes.length = [];
        router.app.carregando = false;

        if (error.config.baseURL == url_api) {
            const status = Number.parseInt(error.response.status);
            if (status == 404) {
                router.push('404');
            }
        }  
        return Promise.reject(error);
    }
);


export default {

    anexoAto: {
        listar(ato_id) {
            return api.get(`/v1/edicoes/atos/${ato_id}/anexos`);
        },

        listarPublicados(ato_id) {
            return api.get(`/v1/edicoes/atos/${ato_id}/anexos/publicado`);
        },

        obterPublicado(id) {
            return api.get(`/v1/edicoes/atos/anexos/${id}/publicado`);
        },

        incluir(ato_id, anexo) {
            return api.post(`/v1/edicoes/atos/${ato_id}/anexos`, anexo);
        },

        excluir(id) {
            return api.delete(`/v1/edicoes/atos/anexos/${id}`);
        },
    },

    ato: {
        listar(parametros, edicao_id) {
            return api.get(`/v1/edicoes/${edicao_id}/atos`, { params: parametros });
        },

        obter(id) {
            return api.get(`/v1/edicoes/atos/${id}`);
        }, 

        obterPublicado(id) {
            return api.get(`/v1/edicoes/atos/${id}/publicado`);
        },

        obterPorIdAtoLegado(idAtoLegado){
            return api.get(`/v1/edicoes/atos/buscarPorIdAtoLegado/${idAtoLegado}`);
        },   

        incluir(edicao_id, ato) {
            return api.post(`/v1/edicoes/${edicao_id}/atos`, ato);
        },

        editar(id, ato) {
            return api.put(`/v1/edicoes/atos/${id}`, ato);
        },

        excluir(id) {
            return api.delete(`/v1/edicoes/atos/${id}`);
        },

        pesquisar(parametros) {
            return api.get("/v1/edicoes/atos/pesquisar", { params: parametros });
        },

        incluirDocumentoAto(id, arquivo, documento) {
            let params = {};
            params.arquivo = arquivo;
            params.documento_ato = documento;

            return api.post(`/v1/edicoes/atos/${id}/documentoato`, params);
        },

        excluirDocumentoAto(id) {
            return api.delete(`/v1/edicoes/atos/${id}/documentoato`);
        },

        publicar(id) {
            return api.post(`/v1/edicoes/atos/${id}/publicar`);
        },

        buscarDocumentoConteudoHTML(nome_minio, prefix) {
            let api = axios.create({ baseURL: url_api, responseType: 'text', method: 'GET', });
            let url = `/v1/documentos/${nome_minio}`;
            if(prefix){
               url += `?prefix=${prefix}`;
            }
            return api.get(url);
        }
    },

    categoriaAto: {
        listar(parametros) {
            return api.get("/v1/categoriasato", { params: parametros });
        },

        obter(id) {
            return api.get(`/v1/categoriasato/${id}`);
        },

        incluir(categoriaAto) {
            return api.post("/v1/categoriasato", categoriaAto);
        },

        editar(categoriaAto) {
            return api.put(`/v1/categoriasato/${categoriaAto.id}`, categoriaAto);
        },

        excluir(id) {
            return api.delete(`/v1/categoriasato/${id}`);
        }
    },

    documento:{
        downloadBlob(nome_minio, prefix) {
            var api = axios.create({ baseURL: url_api, responseType: 'blob', method: 'GET', });
            let url = `/v1/documentos/${nome_minio}`;
            if(prefix){
               url += `?prefix=${prefix}`;
            }
            return api.get(url);
        },
        converterWordParaHTML(params) {
            return api.post("/v1/documentos/convertWordToHTML",  params );
        },
    },

    edicao: {
        maxNumeroEdicao() {
            return api.get("/v1/edicoes/maxnumero")
        },

        listar(parametros) {
            return api.get("/v1/edicoes", { params: { numero_edicao: parametros.numero_edicao, data_inicio: parametros.data_inicio, data_fim: parametros.data_fim, } });
        },

        obter(id) {
            return api.get(`/v1/edicoes/${id}`);
        },

        obterPublicado(id) {
            return api.get(`/v1/edicoes/${id}/publicado`);
        },


        incluir(edicao) {
            return api.post("/v1/edicoes", edicao);
        },

        editar(id, edicao) {
            return api.put(`/v1/edicoes/${id}`, edicao);
        },

        excluir(id) {
            return api.delete(`/v1/edicoes/${id}`);
        },

        pesquisar(parametros) {
            return api.get("/v1/edicoes/pesquisar", { params: parametros });
        },

        ultimaPublicacao() {
            return api.get("/v1/edicoes/buscarultimapublicacao");
        },

        buscarPublicacaoPorData(parametro) {
            return api.get("/v1/edicoes/buscarpublicacaopordata", { params: parametro });
        },

        sumario(id) {
            return api.get(`/v1/edicoes/${id}/sumario`);
        },

        incluirDocumentoCapa(id, params) {
            return api.post(`/v1/edicoes/${id}/documentocapa`, params);
        },

        excluirDocumentoCapa(id) {
            return api.delete(`/v1/edicoes/${id}/documentocapa`);
        },

        incluirDocumentoJornal(id, arquivo, nome_arquivo, codigo_assinatura_digital) {
            let params = {};
            params.arquivo = arquivo;
            params.nome_arquivo = nome_arquivo;
            params.codigo_assinatura_digital = codigo_assinatura_digital;

            return api.post(`/v1/edicoes/${id}/documentojornal`, params);
        },

        excluirDocumentoJornal(id) {
            return api.delete(`/v1/edicoes/${id}/documentojornal`);
        },

    },

    orgao: {
        buscar(parametros) {
            return api.get("/v1/orgaos/buscar", { params: parametros });
        },

        listar() {
            return api.get("/v1/orgaos");
        },

        editar(orgao, id) {
            return api.put(`/v1/orgaos/${id}`, orgao);
        },
    },

    expediente: {
        listar() {
            return api.get("/v1/expediente");
        },
        salvar(params) {
            return api.post("/v1/expediente", params);
        },
    },

    assinaturadigital: {
        iniciar(tipo, params) {
            return api.post(`/v1/assinaturadigital/${tipo}/iniciar`, params);
        },

        finalizar(tipo, params) {
            return api.post(`/v1/assinaturadigital/${tipo}/finalizar`, params);
        },

        autenticidade(code) {
            return api.get(`/v1/assinaturadigital/pdf/verificarautenticidade?codigo_assinatura_digital=${code}`);
        }
    },

};